import { useState, useContext } from "react";
import { Navigate } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { AuthContext } from "./Context/AuthContext";
import Login from "./Pages/Login/Login";
import Party from "./Pages/Party/Party";
import Layout from "./Layout/Layout";
import Setting from "./Pages/Setting/Setting";
import Page404 from "./Pages/Page404/Page404";
import Dashboard from "./Pages/Dashboard/Dashboard";
import MeetingType from "./Pages/MeetingType/MeetingType";
import User from "./Pages/User/User";
import { useGetUserLogin } from "./Hooks/useGetUserLogin";
import Mandate from "./Pages/Mandate/Mandate";
import MemberInMandate from "./Pages/MemberInMandate/MemberInMandate";
import CouncilPositions from "./Pages/CouncilPositions/CouncilPositions";
import Member from "./Pages/Member/Member";
import MemberDetails from "./Pages/MemberDetails/MemberDetails";
import Major from "./Pages/Major/Major";
import InstituteOrUniversity from "./Pages/InstituteOrUniversity/InstituteOrUniversity";
import MemberDetailsForMember from "./Pages/MemberDetails/MemberDetailsForMember";
import CapitalProvince from "./Pages/CapitalProvince/CapitalProvince";
import District from "./Pages/District/District";
import PartiesAndCandidates from "./Pages/PartiesAndCandidates/PartiesAndCandidates";
import MemberDetailsForParty from "./Pages/MemberDetails/MemberDetailsForParty";
import ReasonOfLossMember from "./Pages/ReasonOfLossMember/ReasonOfLossMember";
import Secretarait from "./Pages/Secretarait/Secretarait";
import MemberDetailsForSecretary from "./Pages/MemberDetails/MemberDetailsForSecretary";
import WorkGroup from "./Pages/WorkGroup/WorkGroup";
import PublicForum from "./Pages/PublicForum/PublicForum";
import QuestionAndAnswer from "./Pages/PublicForum/QuestionAndAnswer"

const getToken = () => {
  const token = window.localStorage.getItem("token");
  return token || "";
};

const getMandate = () => {
  const mandate = window.localStorage.getItem("mandate_id");
  return mandate || "";
};

export default function Router({ prefersDarkMode, setPrefersDarkMode }) {
  const { state } = useContext(AuthContext);

  useGetUserLogin();

  // ====================== check state user login ==========================
  const token = getToken();
  const [mandate, setMandate] = useState(getMandate());

  // useEffect(() => {
  //   async function checkUser() {
  //     let userToke = await JSON.parse(window.localStorage.getItem("token"));

  //     if (userToke) {
  //       setToken(userToke);
  //       return;
  //     }

  //     if (state?.user?.token !== null && state?.user?.token !== undefined) {
  //       setToken(state?.user?.token);
  //       window.localStorage.setItem(
  //         "token",
  //         JSON.stringify(state?.user?.token)
  //       );
  //     } else {
  //       setToken(null);
  //     }
  //   }

  //   setTimeout(() => {
  //     checkUser();
  //   }, 2000);
  // }, [state?.user]);

  // End check Route =============================
  const LoginPage = useRoutes([
    { path: "/", element: <Login /> },
    { path: "/login", element: <Login /> },
    { path: "*", element: <Login /> },
  ]);

  const SelectMandatePage = useRoutes([
    { path: "/", element: <Mandate /> },
    { path: "*", element: <Mandate /> },
  ]);

  const Content = useRoutes([
    {
      path: "/",
      element: (
        <Layout
          to="/dashboard"
          prefersDarkMode={prefersDarkMode}
          setPrefersDarkMode={setPrefersDarkMode}
        />
      ),
      children: [
        { path: "/", element: <Navigate to="/dashboard" /> },
        { path: "/dashboard", element: <Dashboard /> },
        { path: "/setting", element: <Setting /> },
        { path: "/setting/user", element: <User /> }, 
        { path: "/setting/party", element: <Party /> },
        { path: "/setting/reason-of-loss-member", element: <ReasonOfLossMember /> },
        {
          path: "/setting/institute-or-university",
          element: <InstituteOrUniversity />,
        },
        { path: "/setting/major", element: <Major /> },
        { path: "/setting/member", element: <Member /> },
        { path: "/member-in-mandate", element: <MemberInMandate /> }, 
        { path: "/secretarait", element: <Secretarait />},
        { path: "/parties-and-candidates", element: <PartiesAndCandidates /> }, 
        { path: "/setting/meeting-type", element: <MeetingType /> },
        { path: "/setting/capital-province", element: <CapitalProvince /> },
        {
          path: "/setting/capital-province/district",
          element: <District />,
        },
        { path: "/setting/council-positions", element: <CouncilPositions /> },
        {
          path: "/setting/member/member-details",
          element: <MemberDetailsForMember />,
        },
        {
          path: "work-group",
          element: <WorkGroup />,
        },
        {
          path: "/member-in-mandate/member-details",
          element: <MemberDetails />,
        },
        {
          path: "/secretary-in-mandate/details", 
          element: <MemberDetailsForSecretary />,    
        },
        {
          path: "/parties-and-candidates/member-details", 
          element: <MemberDetailsForParty />,    
        },
        {
          path: "/public-forum",
          element: <PublicForum />
        },
        {
          path: "/public-forum/question-and-anwser",
          element: <QuestionAndAnswer />
        },
        { path: "*", element: <Page404 /> },
      ],
    },
  ]);

  if (!token) return LoginPage;
  else if (!mandate) return SelectMandatePage;
  else return Content;
}
